import { request } from '@/utils/request'
import { translate } from '@/utils/validation'

export const fields = {
    firstName: 'First Name',
    lastName: 'Last Name',
    middleName: 'Middle Name',
    colloquialName: 'Colloquial Name',
    gender: 'Gender',
    birthDate: 'Birth Date',
    spouseNames: 'Spouse Names',
    published: 'Published',
    tags: 'Tags',
}

export function searchProviderExecutives(providerId, query, limit, includeExisting) {
    return request.get(`/api/manage/providers/${providerId}/executives/search`, {
        query,
        'page.limit': limit,
        includeExisting: includeExisting ?? false,
    })
}

const ExecutiveService = {
    get(id) {
        return request.get(`/api/manage/executives/${id}`)
    },
    list() {
        return request.get('/api/manage/executives')
    },
    getProviderExecutive(providerId, providerEntityId) {
        return request.get(`/api/manage/providers/${providerId}/executives/${providerEntityId}`)
    },
    async update(executive) {
        const response = await request.put(`/api/manage/executives/${executive.id}`, executive)
        if (response.status === 422) {
            translate(response.content, fields)
        }
        return response
    },
    async insert(executive) {
        const response = await request.post(`/api/manage/executives`, executive)
        if (response.status === 422) {
            translate(response.content, fields)
        }
        return response
    },
    import(factSetEntityId, tags) {
        return request.post(`/api/manage/executives/import`, { factSetEntityId, tags })
    },
    searchProvider(id, providerId) {
        return request.get(`/api/manage/providers/${providerId}/search/${id}`)
    },
    getExecutiveIdentificationDeltas(executiveId, providerId) {
        return request.get(`/api/manage/executives/${executiveId}/identifications/deltas/${providerId}`)
    },
    publish(id) {
        return request.post(`/api/manage/executives/${id}/publish`)
    },
    unpublish(id) {
        return request.delete(`/api/manage/executives/${id}/publish`)
    },
    async getJobHistoryConfirmedDate(id) {
        let { content } = await request(`/api/manage/executives/${id}/job-history-confirmed-date`)
        return content.substring(0, 10)
    },
    async updateJobHistoryConfirmedDate(id, date) {
        return await request.put(`/api/manage/executives/${id}/job-history-confirmed-date`, {
            jobHistoryConfirmedDate: date,
        })
    },
    searchParagonExecutives(query, limit, offset) {
        return request.get('/api/manage/executives/search', {
            query,
            'page.limit': limit,
            'page.offset': offset,
        })
    },
    searchProviderExecutives,
}

export default ExecutiveService
